__turbopack_context__.v({
  "radiobutton": "_256lyG_radiobutton",
  "radiobuttongroup": "_256lyG_radiobuttongroup",
  "radiobuttongroup__content": "_256lyG_radiobuttongroup__content",
  "radiobuttongroup__withcontent": "_256lyG_radiobuttongroup__withcontent",
  "radiobuttonlabel": "_256lyG_radiobuttonlabel",
  "radiobuttonwrapper": "_256lyG_radiobuttonwrapper",
});
